import React, { useState } from 'react'
import { PanelBarGLPure, GridSelectionHLPure, ButtonAddHLPure, DialogSystemGLPure } from '../../pures';
import { Grid, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const DocumentPanelBarVersions = (props) => {

    let {
        versions,
        handleSelectVersion,
        handleDeleteFileVersion,
        showVersionsBtns,
        handleMakeVersionMainDoc,
        isInDeleteFlow
    } = props

    const { t } = useTranslation()
    const is560 = useMediaQuery('(max-width:560px)');
    const is960 = useMediaQuery('(max-width:960px)');
    const is1140 = useMediaQuery('(max-width:1140px)');

    const headerColumnOne = (props) => {
        return <span className='documentPanelBarVersions-header-cell-one'>{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className={`documentPanelBarVersions-cell-one ${props.dataItem.selected ? 'documentPanelBarVersions-cell-selected' : ''}`} onClick={() => handleSelectVersion(props.dataItem)}>
                <div className={'gridHLPure-containerLabel'}>
                    {
                        ((props.dataItem.statusType === process.env.REACT_APP_FILE_STATUS_MAIN_DOC || props.dataItem.statusType === process.env.REACT_APP_FILE_STATUS_MAIN_EXP)) ? (
                            <span className='gridHLPure-userName'>
                                {t('documentPanelBarVersions.main.version')}
                            </span>
                        ) : <span className='gridHLPure-userName'>
                            {t('documentPanelBarVersions.previous.version')}
                        </span>
                    }
                    <div className='gridHLPure-detailsContainer'>
                        <span className='gridHLPure-fieldSubtitle'>
                            {props.dataItem.date}
                        </span>
                    </div>
                </div>
            </td>
        );
    };

    const heightGrid = 'var(--panelHeight)'

    const [showVersionModal, setVersionModal] = useState(false)
    const [versionSelected, setVersionSelected] = useState({})

    const handleShowVersionModal = (versionDoc) => {
        setVersionModal(true)
        setVersionSelected(versionDoc)
    }

    const handleCloseVersionModal = () => {
        setVersionModal(false)
    }

    const handleDeleteVersion = () => {
        setVersionModal(false)
        handleDeleteFileVersion(versionSelected.id)
    }

    // Decorate versions with per-row flags consumed by GridSelectionHLPure/cellActions
    const versionsWithActions = (versions || []).map(v => {
        const isVersion = (v.statusType === process.env.REACT_APP_FILE_STATUS_VER_EXP || v.statusType === process.env.REACT_APP_FILE_STATUS_VER_DOC)
        const actionsEnabled = isVersion && !isInDeleteFlow
        return {
            ...v,
            // Show first action button ("Convertir a principal") only for previous versions
            mainDoc: actionsEnabled,
            // Control visibility/enablement of trash icon per row
            iconTrashActive: actionsEnabled,
            disableTrash: !actionsEnabled,
        }
    })

    return (
        <div className='documentPanelBarVersions-container'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t('documentPanelBarVersions.versions.document')}
                className='documentPanelBarVersions'
                id='documentPanelBarVersions'
                actionComponent={
                    <ButtonAddHLPure
                        nameBtn={is1140 ?
                            is960
                                ? is560
                                    ? ''
                                    : t('documentPanelBarVersions.btn.add')
                                : ''
                            : t('documentPanelBarVersions.btn.add')}
                        onClickBtn={props.handleShowDialogVersion}
                        iconAdd
                        disabled={isInDeleteFlow || !props?.permissions?.version}
                    />
                }
            >
                <Grid item className='documentPanelBarVersions-grid-documents'>
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={'documentPanelBarVersions-general-grid'}
                        pageable={false}
                        skip={0}
                        take={versions.length}
                        dataGrid={versionsWithActions}
                        filter={false}
                        // columnTwo={true}
                        titleRow1={t('documentPanelBarVersions.date')}
                        headerColumnOne={headerColumnOne}
                        cellColumnOne={cellColumnOne}
                        styleGrid={{ height: heightGrid }}
                        columnFive={(showVersionsBtns) ? true : null}
                        titleRow5={t('documentPanelBarVersions.action')}
                        headerColumnFiveClass={'documentPanelBarVersions-header-cell-two'}
                        iconOneActiveSelected={"mainDoc"}
                        labelOneActions={t('documentPanelBarVersions.btn.actual')}
                        activeDialog1
                        btnOpenDialog1={handleMakeVersionMainDoc}
                        iconTrashActive
                        activeDialogTrash
                        btnOpenDialogTrash={handleShowVersionModal}
                        labelTrashActions={t('documentPanelBarVersions.delete.version')}
                        tooltipTrashIcon={t('documentPanelBarVersions.delete.version')}
                        onSelectedItem={(item) => {
                            if (item && Object.values(item).length === 0) return

                            if (!item.mainDoc) return
                            handleMakeVersionMainDoc(item)
                        }}
                        setNameComponentUser={() => { }}
                        setShowDetails={(value) => { }}
                    />
                </Grid>
            </PanelBarGLPure>
            {
                showVersionModal && (
                    <DialogSystemGLPure
                        showConfirm={showVersionModal}
                        confirmTitle={t('documentPanelBarVersions.title.modal')}
                        confirmMessage={t('documentPanelBarVersions.question.modal')}
                        handleConfirmDeleteFlowClose={handleCloseVersionModal}
                        handleConfirmDeleteFlowSubmit={handleDeleteVersion}
                        labelCancelConfirmation={t('button.cancel')}
                        labelSubmitConfirmation={t('button.delete')}
                    />
                )
            }
        </div>
    )
}

export { DocumentPanelBarVersions as default }